<div class="inline-edit-wrapper">
  <i [class.hover-done]="canRemove" class="material-symbols-outlined material-symbols-outlined-done">done</i>
  <i [class.hover-close]="canRemove" class="material-symbols-outlined material-symbols-outlined-close">highlight_off</i>
  <div
    class="filters-lozenge-inline-edit-text text-truncate"
    [app-tooltip]="{ message: tooltip?.message}"
    [showTooltip]="!!tooltip"
  >
    <ng-content></ng-content>
  </div>
</div>
